export const ActivityKeys = {
	all: ["activities"] as const,
	detail: (id: number) => [...ActivityKeys.all, "detail", id] as const,
	detailNotes: (id: number) =>
		[...ActivityKeys.all, "detail-notes", id] as const,
	detailAgents: (id: number) =>
		[...ActivityKeys.all, "detail-agents", id] as const,
	detailParticipants: (id: number) =>
		[...ActivityKeys.all, "detail-participants", id] as const,
	list: (
		filterDatefrom?: string,
		filterDateto?: string,
		filterOnlyunsolved?: boolean,
		filterOnlysolved?: boolean,
		limit?: number,
		offset?: number,
	) =>
		[
			...ActivityKeys.all,
			"list",
			filterDatefrom,
			filterDateto,
			filterOnlyunsolved,
			filterOnlysolved,
			limit,
			offset,
		] as const,
	events: () => [...ActivityKeys.all, "events"] as const,
};
